// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2SA0x","wrapper":"Footer_wrapper__3rlZ8"};